import React from 'react';

import styles from '../../../../pages/ClubProfiles/club.scss';
import { getClickAttrs } from '../../../Analytics/gtag';

const SchedulePlayButton = (props) => {
    return (
        <button
            type="button"
            className={`btn btn-primary ${props.small ? 'btn-sm ' : ''} text-uppercase ${styles.primaryActionButton}`}
            onClick={props.onClick}
            {...getClickAttrs({
                category: 'Create Event',
                context: 'Schedule Play Button',
                location: props.clickLocation,
            })}
        >
            Schedule Play
        </button>
    );
};

export default SchedulePlayButton;
